import { render, staticRenderFns } from "./stockOrderDetails.vue?vue&type=template&id=0d283a0c&scoped=true"
import script from "./stockOrderDetails.vue?vue&type=script&lang=js"
export * from "./stockOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./stockOrderDetails.vue?vue&type=style&index=0&id=0d283a0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d283a0c",
  null
  
)

export default component.exports